module.exports = __webpack_public_path__ + "static/media/ui-card.b335f240.svg";